// extracted by mini-css-extract-plugin
export default {"taskEmpty":"styles_taskEmpty__-f1U5","message":"styles_message__2dYWa"};